var map = {
	"./BookOpen_2022.svg": 70936,
	"./Envelope_2022.svg": 61725,
	"./Link_2022.svg": 25433,
	"./arrow-down-wide.svg": 12260,
	"./arrow-down.svg": 72788,
	"./arrow-rounded.svg": 683,
	"./arrow-short.svg": 86726,
	"./arrows-right.svg": 72087,
	"./asterix.svg": 90850,
	"./book.svg": 49619,
	"./calendar.svg": 46726,
	"./camera.svg": 27313,
	"./category-apple.svg": 15419,
	"./category-building.svg": 97141,
	"./category-democracy.svg": 47144,
	"./category-factory.svg": 61645,
	"./category-globe.svg": 39912,
	"./category-grain.svg": 27726,
	"./category-handshake.svg": 53284,
	"./category-heart.svg": 35595,
	"./category-iceberg.svg": 47396,
	"./category-ocean.svg": 7781,
	"./category-oil-drum.svg": 16524,
	"./category-people.svg": 41768,
	"./category-sami.svg": 26435,
	"./category-science.svg": 23677,
	"./category-tree.svg": 9309,
	"./category-windmill.svg": 76385,
	"./change.svg": 86052,
	"./chat.svg": 52814,
	"./check-circle.svg": 39433,
	"./checkmark.svg": 34927,
	"./clock.svg": 46990,
	"./close-small.svg": 89962,
	"./document.svg": 87695,
	"./download-circle.svg": 60905,
	"./download-round-large.svg": 2457,
	"./download-round.svg": 67363,
	"./download-small.svg": 2174,
	"./download.svg": 22044,
	"./downtime.svg": 80083,
	"./dubian-path.svg": 88533,
	"./envelope.svg": 25192,
	"./error-page.svg": 23370,
	"./exclamation-mark-color.svg": 8233,
	"./exclamation-mark.svg": 10235,
	"./expand-collapse.svg": 69152,
	"./external-link-arrow-skinny.svg": 69519,
	"./external-link-arrow.svg": 8970,
	"./facebook-logo.svg": 81232,
	"./facebook.svg": 85048,
	"./file.svg": 79326,
	"./filter-small.svg": 27096,
	"./flag.svg": 36490,
	"./globe-old.svg": 5707,
	"./globe.svg": 58115,
	"./house.svg": 91112,
	"./i.svg": 26485,
	"./info-color.svg": 95370,
	"./info.svg": 44200,
	"./link-arrow-circled.svg": 41019,
	"./link-arrow.svg": 76928,
	"./link.svg": 29636,
	"./linkedin-logo.svg": 27418,
	"./linkedin.svg": 75050,
	"./long-arrow.svg": 42074,
	"./mail-square.svg": 25115,
	"./mail-thick.svg": 15481,
	"./mail.svg": 50473,
	"./menu.svg": 61513,
	"./micro-arrow-down.svg": 98461,
	"./minus-small.svg": 42014,
	"./navigation-arrow.svg": 42422,
	"./np-1.svg": 45324,
	"./np-2.svg": 24351,
	"./np-3.svg": 93358,
	"./np-4.svg": 4913,
	"./np-5.svg": 6880,
	"./np-6.svg": 51539,
	"./np-circle.svg": 51699,
	"./np-close.svg": 12145,
	"./np-dash-bottom-right.svg": 88688,
	"./np-dash-top-right.svg": 61672,
	"./np-dash-top-top.svg": 5719,
	"./np-long-horizontal.svg": 51426,
	"./np-long-vertical.svg": 29680,
	"./np-rectangle.svg": 44058,
	"./np-snake-horizontal.svg": 51418,
	"./np-snake-vertical.svg": 6168,
	"./open-arrow-circle.svg": 3357,
	"./person.svg": 86139,
	"./play.svg": 22554,
	"./plus-circle.svg": 40417,
	"./plus-small.svg": 81718,
	"./rss.svg": 25920,
	"./search.svg": 1768,
	"./share-big.svg": 32584,
	"./share-new-profile-small.svg": 18938,
	"./share-purple.svg": 308,
	"./share-small.svg": 22751,
	"./slideshow.svg": 15232,
	"./small-arrow-down.svg": 99114,
	"./small-arrow-right.svg": 7468,
	"./some-facebook.svg": 86805,
	"./some-instagram.svg": 21983,
	"./some-linkedin.svg": 46411,
	"./some-rss.svg": 523,
	"./sort-down.svg": 10257,
	"./sort-up.svg": 47726,
	"./star.svg": 71932,
	"./stop.svg": 61820,
	"./video.svg": 80797,
	"./volume.svg": 87618,
	"./warning-circle.svg": 69845,
	"./warning-color.svg": 53674,
	"./warning-triangle.svg": 54561,
	"./warning.svg": 29928,
	"./wrench.svg": 3871,
	"./x-circle.svg": 42353,
	"./x-rounded.svg": 4440,
	"./x-straight.svg": 27603,
	"./x.svg": 46468
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26112;